import { graphql } from 'parkdepot-shared/gql'

export const B2C_GET_CARPAY_LOTS = graphql(`
    query b2c_get_carpay_lots {
        b2c_get_carpay_lots {
            lots {
                lot_id
                name
                address
                longitude
                latitude
            }
        }
    }
`)
